import { loading, success, handleErrorException } from 'State/actions';
import { TitleEnum } from 'Common/Constants/Enumeration/CommonEnum';

import * as types from './types';

export const getKitchenPrepWorksheetItems = requestObj => {
  return async (dispatch, getState, MPWWebApi) => {
    dispatch(loading(types.KITCHEN_PREP_WORKSHEET_LOADING, true));
    try {
      const response = await MPWWebApi.postGenericInsertUpdate(
        'CentralKitchen/GetPreparedKitchenItems',
        requestObj
      );
      dispatch(success(types.KITCHEN_PREP_WORKSHEET_DATA, response.data.Data));
    } catch (ex) {
      const defaultError = {
        Title: TitleEnum.Error,
        Message:
          'An error occurred while fetching kitchen prep worksheet list. Please try again.',
      };
      dispatch(
        handleErrorException(
          ex,
          types.KITCHEN_PREP_WORKSHEET_FETCHING_ERROR,
          defaultError
        )
      );
    } finally {
      dispatch(loading(types.KITCHEN_PREP_WORKSHEET_LOADING, false));
    }
  };
};

export const getWarehouseKitchenList = () => {
  return async (dispatch, getState, MPWWebApi) => {
    dispatch(loading(types.FETCH_WAREHOUSE_KITCHEN_LIST_LOADING, true));
    try {
      const response = await MPWWebApi.getGeneric('sitemaster');
      dispatch(success(types.WAREHOUSE_KITCHEN_LIST_DATA, response.data.Data));
    } catch (ex) {
      const defaultError = {
        Title: TitleEnum.Error,
        Message:
          'An error occurred while fetching Kitchen list. Please try again.',
      };
      dispatch(
        handleErrorException(
          ex,
          types.FETCH_WAREHOUSE_KITCHEN_LIST_LOADING_ERROR,
          defaultError
        )
      );
    } finally {
      dispatch(loading(types.FETCH_WAREHOUSE_KITCHEN_LIST_LOADING, false));
    }
  };
};

export const printKitchenPrepWorksheetData = printRequestData => {
  return async (dispatch, getState, MPWWebApi) => {
    dispatch(loading(types.PRINT_KITCHEN_PREP_WORKSHEET_LOADING, true));
    try {
      const response = await MPWWebApi.postGenericInsertUpdate(
        'CentralKitchen/GetPreparedKitchenItemsReport',
        printRequestData
      );
      dispatch(
        success(types.PRINT_KITCHEN_PREP_WORKSHEET_DATA, response.data.Data)
      );
    } catch (err) {
      const defaultError = {
        Title: TitleEnum.Error,
        Message: 'An error occurred while creating PDF. Please try again.',
      };
      dispatch(
        handleErrorException(
          err,
          types.PRINT_KITCHEN_PREP_WORKSHEET_ERROR,
          defaultError
        )
      );
    } finally {
      dispatch(loading(types.PRINT_KITCHEN_PREP_WORKSHEET_LOADING, false));
    }
  };
};

export const closeKitchenPrepWorksheet = requestObj => {
  return async (dispatch, getState, MPWWebApi) => {
    dispatch(loading(types.KITCHEN_PREP_WORKSHEET_CLOSE_LOADING, true));
    try {
      const response = await MPWWebApi.postGenericInsertUpdate(
        'CentralKitchen/WriteKitchenPrepWorksheetToClose',
        requestObj
      );
      dispatch(success(types.KITCHEN_PREP_WORKSHEET_CLOSE, response.data.Data));
    } catch (ex) {
      const defaultError = {
        Title: TitleEnum.Error,
        Message:
          'An error occurred while closing kitchen prep worksheet list. Please try again.',
      };
      dispatch(
        handleErrorException(
          ex,
          types.KITCHEN_PREP_WORKSHEET_CLOSE_ERROR,
          defaultError
        )
      );
    } finally {
      dispatch(loading(types.KITCHEN_PREP_WORKSHEET_CLOSE_LOADING, false));
    }
  };
};
export const setToDateMin = payload => {
  return {
    type: types.SET_TO_DATE_MIN,
    payload,
  };
};
export const setFromDateMax = payload => {
  return {
    type: types.SET_FROM_DATE_MAX,
    payload,
  };
};

export const clearKitchenErrors = () => {
  return {
    type: types.CLEAR_KITCHEN_ERROR,
  };
};
export const clearPrintData = () => {
  return {
    type: types.CLEAR_PRINT_KITCHEN_PREP_WORKSHEET_DATA,
  };
};



// WEBPACK FOOTER //
// ./src/pages/centralkitchen/kitchenprepworksheet/state/kitchenPrepWorksheet/actions.js